module.exports = __webpack_public_path__ + "img/wu.1f524903.svg";